export default __webpack_public_path__ + "static/media/circle3.d2e5b4c5.svg";